const ENV_VAR_MAP: Record<string, string> = {
  google: 'GOOGLE_API_KEY',
  openai: 'OPENAI_API_KEY',
  huggingface: 'HUGGINGFACE_API_KEY',
};

/** Get the env-provided API key for a provider. */
export function getEnvApiKey(provider: string): string {
  const varName = ENV_VAR_MAP[provider];
  if (!varName) return '';
  return (import.meta.env[varName] as string) ?? '';
}

/** Check if an env-provided API key exists for a provider. */
export function hasEnvApiKey(provider: string): boolean {
  return getEnvApiKey(provider).length > 0;
}

/** Resolve API key: user-entered (store) takes priority over env var. */
export function resolveApiKey(provider: string, storeKey: string): string {
  if (storeKey) return storeKey;
  return getEnvApiKey(provider);
}
